export class ComplaintModel {
    title: string;
    description: string;
    categoryID: number;
    gpsx: number;
    gpsy: number;
    locationDescription: string;
}
